// import React from "react";

// function DeliveryDateButton (props) {
//     return(
//         <div>
//             <div>
//                 <div id={props.instance.id}>
//                     <p className="text-center">{props.instance.dayName}</p>
//                 </div>
//                 <div>
//                     <p className="text-center">{props.instance.dayNumber}</p>
//                 </div>
//                 <div>
//                     <p className="text-center">{props.instance.monthName}</p>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default DeliveryDateButton;


import React from "react";

function DeliveryDateButton(props) {
    return (
        <div className="flex flex-col items-center py-3 px-2">
            <p className="text-[11px] font-medium text-[#a02338] uppercase tracking-widest leading-none mb-1">
                {props.instance.dayName}
            </p>
            <p className="text-[28px] font-bold text-[#2a1419] leading-none my-1">
                {props.instance.dayNumber}
            </p>
            <p className="text-[11px] font-medium text-gray-400 uppercase tracking-wide leading-none">
                {props.instance.monthName}
            </p>
        </div>
    );
}

export default DeliveryDateButton;